import { api } from './client';

export const MODALITIES = [
  { value: 'delivery', label: 'Delivery',       short: 'Delivery', needs: 'address' },
  { value: 'takeaway', label: 'Para viagem',    short: 'Viagem',   needs: null },
  { value: 'dine_in',  label: 'Consumir aqui',  short: 'No local', needs: 'tableLabel' },
];

export const STATUSES = {
  awaitingPayment: 'awaiting_payment',
  preparing: 'preparing',
  ready: 'ready',
  cancelled: 'cancelled',
};

/**
 * Etapas do quadro. Os ids são os próprios status do backend, sem tabela de/para.
 * Fica aqui, e não no OrdersKanban, porque o modal de detalhes também precisa:
 * um importando do outro fecharia um ciclo, já que o quadro renderiza o modal.
 */
export const COLUMNS = [
  {
    id: STATUSES.awaitingPayment,
    label: 'Confirmação de pagamento',
    shortLabel: 'Pagamento',
    color: 'var(--color-amber-primary)',
    bg: 'var(--color-amber-ghost)',
    colBg: '#fdf3e0',
  },
  {
    id: STATUSES.preparing,
    label: 'Preparando',
    shortLabel: 'Preparando',
    color: 'var(--color-purple-primary)',
    bg: 'var(--color-purple-ghost)',
    colBg: '#eeedfd',
  },
  {
    id: STATUSES.ready,
    label: 'Pronto',
    shortLabel: 'Pronto',
    color: '#2a9d5c',
    bg: '#edfaf3',
    colBg: '#e6f8ef',
  },
];

export function listOrders() {
  return api.get('/establishments/me/orders');
}

/** Rótulo de cada forma de pagamento, para o quadro e o detalhe. Fica aqui, ao
 *  lado de MODALITIES, porque é o mesmo tipo de vocabulário: valor do servidor
 *  de um lado, texto em português do outro.
 *
 *  Pedido sem forma registrada é pedido de balcão ou anterior à coluna. Aparece
 *  como "não informado" em vez de um chute — o lojista precisa saber que ninguém
 *  declarou, não receber uma forma inventada. */
export const PAYMENT_LABELS = {
  pix: 'Pix',
  cash: 'Dinheiro',
  credit: 'Crédito',
  debit: 'Débito',
};

export function paymentLabel(value) {
  return PAYMENT_LABELS[value] || 'Não informado';
}

export function createOrder(data) {
  return api.post('/establishments/me/orders', data);
}

export function updateOrderStatus(orderId, status) {
  return api.patch(`/establishments/me/orders/${orderId}/status`, { status });
}
